{
  "en": "Engels",
  "de": "Duits",
  "fr": "Frans",
  "es": "Spaans",
  "cs": "Tsjechisch",
  "da": "Deens",
  "et": "Ests",
  "fi": "Fins",
  "hr": "Kroatisch",
  "hu": "Hongaars",
  "it": "Italiaans",
  "lt": "Litouws",
  "lv": "Lets",
  "nl": "Nederlands",
  "nb": "Noors Bokmål",
  "pl": "Pools",
  "pt": "Portugees",
  "ro": "Roemeens",
  "sk": "Slowaaks",
  "sl": "Sloveens",
  "sq": "Albanees",
  "sv": "Zweeds"
}
